import NationalTransferQuery from "../../domain/core/payments/NationalTransferQuery";
import { NationalTransferModel } from "../../domain/models/NationalTransfer";
import { IQueryNationalTransferRepository } from "../../domain/ports/payments/IQueryNationalTransferRepository";
import QueryService from "../QueryService";

export class NationalTransferQueryService
  extends QueryService<NationalTransferModel>
  implements IQueryNationalTransferRepository
{
  public constructor(
    public baseURL: string,
    public pathname: string,
  ) {
    super(baseURL, pathname);
    this.api.defaults.headers.common.Accept = "application/json";
  }
}

const BASE_URL = process.env.NEXT_PUBLIC_FLUX_API_URL as string;

const nationalTransferQuery = new NationalTransferQuery(
  new NationalTransferQueryService(BASE_URL, "national_transfers"),
);

export { nationalTransferQuery };
